<template>
    <v-row no-gutters>
        <v-col cols="12">
            <v-sheet class="card-rounded">
                <v-row no-gutters>
                    <!-- ระดับชั้นที่ต้องการสมัคร -->
                    <v-col cols="12" class="pa-4">
                        <v-row no-gutters justify="space-between" class="mb-3">
                            <span class="header-text">{{ $t('message.adminPage.other.otherHeader') }}</span>
                            <v-btn
                                color="primary"
                                small
                                outlined
                                @click="onAction()"
                                class="square-btn"
                            >
                                <v-icon small>
                                    {{
                                        currentStep == 5
                                            ? "mdi-eye"
                                            : "mdi-pencil"
                                    }}</v-icon
                                >
                            </v-btn>
                        </v-row>
                        <v-row no-gutters>
                            <v-col cols="4">
                                <v-row no-gutters>
                                    <span class="caption-text">
                                        {{ $t('message.adminPage.other.former') }}</span
                                    >
                                </v-row>
                                <v-row no-gutters>
                                    <span class="default-text">{{
                                        applicant?.oldSchool
                                    }}</span>
                                </v-row>
                            </v-col>
                            <v-col cols="4">
                                <v-row no-gutters>
                                    <span class="caption-text">
                                        {{ $t('message.adminPage.other.gpax') }}</span
                                    >
                                </v-row>
                                <v-row no-gutters>
                                    <span class="default-text">{{
                                        applicant?.GPAX
                                    }}</span>
                                </v-row>
                            </v-col>
                            <v-col cols="4">
                                <v-row no-gutters>
                                    <span class="caption-text">
                                        {{ $t('message.adminPage.other.lastEducation') }}</span
                                    >
                                </v-row>
                                <v-row no-gutters>
                                    <span class="default-text">{{
                                        applicant?.graduatedLevel?.[`student_year_name_${locale}`]
                                    }}</span>
                                </v-row>
                            </v-col>
                        </v-row>
                        <div v-if="expandDetail">
                            <v-row no-gutters class="my-4">
                                <v-divider></v-divider>
                            </v-row>
                            <v-row no-gutters class="mb-3">
                                <span class="header-text">{{ $t('message.form.topics.healthInformation') }}</span>
                            </v-row>
                            <v-row
                                no-gutters
                                v-if="healthCardInfo?.length != 0"
                                class="mb-4"
                            >
                                <v-col
                                    cols="2"
                                    v-for="(info, i) in healthCardInfo"
                                    :key="i"
                                >
                                    <HealthIndicatorCard
                                        :title="info?.title"
                                        :value="info?.value"
                                    ></HealthIndicatorCard>
                                </v-col>
                            </v-row>
                            <v-row no-gutters>
                                <v-col cols="6" class="mb-3">
                                    <v-row no-gutters>
                                        <span class="caption-text">
                                            {{ $t('message.adminPage.healthInfo.medicalCondition') }}</span
                                        >
                                    </v-row>
                                    <v-row no-gutters>
                                        <span class="default-text">{{
                                            healthInfo?.congenitalDisease
                                        }}</span>
                                    </v-row>
                                </v-col>
                                <v-col cols="6" class="mb-3">
                                    <v-row no-gutters>
                                        <span class="caption-text"> {{ $t('message.adminPage.healthInfo.drugAllergy') }}</span>
                                    </v-row>
                                    <v-row no-gutters>
                                        <span class="default-text">{{
                                            healthInfo?.drugAllergy
                                        }}</span>
                                    </v-row>
                                </v-col>
                                <v-col cols="6">
                                    <v-row no-gutters>
                                        <span class="caption-text">
                                            {{ $t('message.adminPage.healthInfo.regularMedications') }}</span
                                        >
                                    </v-row>
                                    <v-row no-gutters>
                                        <span class="default-text">{{
                                            healthInfo?.regularMedication
                                        }}</span>
                                    </v-row>
                                </v-col>
                                <v-col cols="6">
                                    <v-row no-gutters>
                                        <span class="caption-text">
                                            {{ $t('message.adminPage.healthInfo.remark') }}</span
                                        >
                                    </v-row>
                                    <v-row no-gutters>
                                        <span class="default-text">{{
                                            healthInfo?.note
                                        }}</span>
                                    </v-row>
                                </v-col>
                            </v-row>
                        </div>
                    </v-col>
                </v-row>
            </v-sheet>
        </v-col>
    </v-row>
</template>

<script>
import HealthIndicatorCard from "@/components/admin/Candidates/Applicant/Other/HealthIndicatorCard.vue";
import { RegistrationStatusEnum } from "@/constants";
import i18n from "@/i18n";
export default {
    components: {
        HealthIndicatorCard,
    },
    props: {
        applicantInfo: Object,
        currentStep: String,
    },
    mounted() {
        this.retrievedData();
    },
    computed: {
        locale(){
            return i18n.locale;
        },
        healthInfo() {
            let healthInfo = this.applicant?.healthInfo;
            return {
                weight: healthInfo?.weight ?? "-",
                height: healthInfo?.height ?? "-",
                bloodGroup: healthInfo?.bloodGroup ?? "-",
                congenitalDisease: healthInfo?.congenitalDisease ?? "-",
                drugAllergy: healthInfo?.drugAllergy ?? "-",
                regularMedication: healthInfo?.regularMedication ?? "-",
                note: healthInfo?.note ?? "-",
            };
        },
        expandDetail() {
            if (
                (this.applicant?.registrationStatus ==
                    RegistrationStatusEnum.SUCCESSFUL_CONFIRMATION_DETAIL ||
                    this.applicant?.registrationStatus ==
                        RegistrationStatusEnum.SUCCESSFUL_ENROLLMENT) &&
                (this.currentStep == 3 || this.currentStep == 5)
            )
                return true;
            return false;
        },
        healthCardInfo() {
            try {
                let healthInfo = this.applicant?.healthInfo;
                let basicInfo = [];
                if (healthInfo?.weight)
                    basicInfo.push({
                        title: i18n.t('message.adminPage.healthInfo.weight'),
                        value: healthInfo?.weight,
                    });
                if (healthInfo?.height)
                    basicInfo.push({
                        title: i18n.t('message.adminPage.healthInfo.height'),
                        value: healthInfo?.height,
                    });
                if (healthInfo?.bloodGroup)
                    basicInfo.push({
                        title: i18n.t('message.adminPage.healthInfo.bloodType'),
                        value: healthInfo?.bloodGroup,
                    });
                return basicInfo;
            } catch (error) {
                return [];
            }
        },
    },
    data() {
        return {
            applicant: {},
        };
    },
    methods: {
        retrievedData() {
            let applicant = JSON.parse(JSON.stringify(this.applicantInfo));
            this.applicant = applicant;
        },
        onAction() {
            let action = this.currentStep == 5 ? "view" : "edit";
            this.$emit(`onAction`, action, `other`);
        },
    },
};
</script>

<style scoped lang="scss">
.square-btn {
    min-width: 36px !important;
    width: 36px !important;
    height: 36px !important;
}
.header-text {
    font-family: "Prompt";
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 23px;
    color: #255d98;
}
.caption-text {
    font-family: "Prompt";
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    color: #9d9b9a;
}
.default-text {
    font-family: "Sarabun";
    font-weight: 400;
    font-size: 18px;
    line-height: 24px;
    color: #37323c;
}

[class*="-text"] {
    .v-application[lang="en"] & {
        font-family: "inter", sans-serif !important;
    }
}
.card-rounded {
    background: #ffffff;
    box-shadow: 0px 0px 20px rgba(232, 232, 232, 0.7) !important;
    border-radius: 10px 10px 10px 10px;
}
</style>
